export default "__VITE_ASSET__P8oG0HYw__"